import gql from "graphql-tag";
import { useQuery } from "@apollo/client";
import { useCustomerKey } from "utils/customHooks/useCustomerKey";
import {
  useAlternateTimelines,
  useDataSourceGroups,
} from "components/Dashboard/HubletView/SingleTimeline/singleTimelineStore";
import {
  PRODUCTION_SEGMENTS_QUERY_FILTERED,
  askrClients,
} from "../../providers/AskrProvider";
import { useSelector } from "store/useSelector";
import { TimeRangeFinite } from "types/types";
import { useVisibleProcesses } from "utils/customHooks/genericHooks";
import { FETCH_POLICY } from "segments/AggregatesGetter/aggregatesGetterUtils";
import { useEffect } from "react";
import { INVALID_CUSTOMERS } from "constants/constants";

const DATA_SOURCE_GROUPS_QUERY = gql`
  {
    datasourceGroups {
      id
      name
    }
  }
`;

export function DataSourceGroupsGetter() {
  const ckey = useCustomerKey();

  return ckey && !INVALID_CUSTOMERS.includes(ckey) ? (
    <QueryDataSourceGroups ckey={ckey} />
  ) : null;
}
function QueryDataSourceGroups({ ckey }) {
  const client = askrClients.get(ckey);
  const { setDataSourceGroups } = useDataSourceGroups();
  // fetch the data source groups
  useQuery(DATA_SOURCE_GROUPS_QUERY, {
    client,
    onCompleted: data => {
      if (!data?.datasourceGroups) {
        console.error("No datasourceGroups found");
        console.log(data);
        return;
      }

      setDataSourceGroups(data.datasourceGroups);
    },
  });

  // clear data when we switch customers
  useEffect(() => {
    return () => {
      setDataSourceGroups([]);
    };
  }, [client, setDataSourceGroups]);

  return null;
}

export function AlternateTimelinesGetter() {
  // once we have the data source groups, fetch the timeline
  const { dataSourceGroups } = useDataSourceGroups();

  const visibleRange = useSelector(s => s.legacy.visibleRange);
  const visibleProcesses = useVisibleProcesses();
  const shouldQuery = dataSourceGroups.length > 0 && visibleRange;
  return shouldQuery ? (
    <>
      {visibleProcesses.map(p => (
        <Query key={p.id} {...{ visibleRange, id: p.id }} />
      ))}
    </>
  ) : null;
}
function Query({
  visibleRange,
  id,
}: {
  visibleRange: TimeRangeFinite;
  id: string;
}) {
  const { selectedDataSourceGroups } = useDataSourceGroups();
  const ckey = useCustomerKey();
  const client = askrClients.get(ckey);
  const [, setAlternateTimelines] = useAlternateTimelines();

  useQuery(PRODUCTION_SEGMENTS_QUERY_FILTERED, {
    client,
    variables: {
      machemetrySourceName: id,
      ge: visibleRange.ge.toString(),
      lt: visibleRange.lt.toString(),
      datasourceGroupIds: selectedDataSourceGroups.map(d => d.id),
    },
    fetchPolicy: FETCH_POLICY,
    onCompleted: data => {
      setAlternateTimelines(prev => ({
        ...prev,
        [id]: data.productionSegments,
      }));
    },
  });
  return null;
}
